<template>
  <div class="modal fade" role="dialog" :id="idModal">
    <div class="modal-dialog modal-xs">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body modal-confirmation">
          <div class="row text-center">
            <div class="col-sm-12">
              <div class="modal-wrapper">
                <div class="delete-icon">
                  <i class="ic-close"></i>
                </div>
                <header>Are you sure?</header>
                <p>
                  {{ subContent }}
                </p>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="cancel">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-default" @click="submit">
                    Yes, delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.modal-body -->
      </div>
      <!-- /.modal-content -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    idModal: {
      type: String,
      default: "deletemodal",
    },
    subContent: {
      type: String,
      default:
        "Do you want to delete this record? This process cannot be undone.",
    },
  },
  methods: {
    cancel() {
      $(`#${this.idModal}`).modal("hide");
      this.$emit("cancel");
    },
    submit() {
      $(`#${this.idModal}`).modal("hide");
      this.$emit("submit");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/DeleteModal.vue